import { useEffect } from 'react';

export default function useCursorLoading(loading: boolean) {
  useEffect(() => {
    const original = document.body.style.cursor;
    if (loading) {
      document.body.style.cursor = 'wait';
    } else {
      document.body.style.cursor = original || 'default';
    }
    return () => {
      document.body.style.cursor = original;
    };
  }, [loading]);
}